export default "<app-projects-list></app-projects-list>";